var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxTabIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.8335H2.5",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 18.8333V13",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 18.8333V13",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7735 2.1665H6.22711C5.22476 2.1665 4.72358 2.1665 4.32083 2.41542C3.91808 2.66433 3.69394 3.1126 3.24568 4.00912L3.24568 4.00912L2.15781 6.75913C1.83352 7.57889 1.54043 8.58212 2.17309 9.19606C2.47315 9.48724 2.88242 9.6665 3.33359 9.6665C4.25406 9.6665 5.00025 8.92031 5.00025 7.99984C5.00025 8.92031 5.74645 9.6665 6.66692 9.6665C7.58739 9.6665 8.33359 8.92031 8.33359 7.99984C8.33359 8.92031 9.07978 9.6665 10.0003 9.6665C10.9207 9.6665 11.6669 8.92031 11.6669 7.99984C11.6669 8.92031 12.4131 9.6665 13.3336 9.6665C14.2541 9.6665 15.0003 8.92031 15.0003 7.99984C15.0003 8.92031 15.7464 9.6665 16.6669 9.6665C17.1181 9.6665 17.5274 9.48724 17.8275 9.19604C18.4601 8.58212 18.1671 7.57889 17.8428 6.75913L16.7549 4.00912C16.3066 3.1126 16.0825 2.66433 15.6797 2.41542C15.277 2.1665 14.7758 2.1665 13.7735 2.1665Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTabIcon);
export default __webpack_public_path__ + "static/media/BoxTabIcon.b14bd3dcfebc6b1d59ad18e90589e5af.svg";
export { ForwardRef as ReactComponent };